import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import servicesData from '../../data/servicesData';
import './ServiceDetail.css';

export default function ServiceDetail() {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const service = servicesData.find((s) => s.id === serviceId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceId]);

  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  if (!service) {
    return (
      <div className="service-detail-page">
        <div className="service-not-found">
          <h1>Service Not Found</h1>
          <p>The service you're looking for doesn't exist.</p>
          <Link to="/services" className="btn-primary">
            Back to Services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-page">
      <div className="service-detail-hero">
        <div className="service-detail-hero-content">
          <Link to="/services" className="back-link">
            <i className="fas fa-arrow-left"></i> All Services
          </Link>
          <h1>{service.title}</h1>
          <p>{service.description}</p>
        </div>
      </div>

      <section className="service-detail-section">
        <div className="service-detail-container">
          <div className="service-detail-intro">
            <h2>Available Alterations</h2>
            <p>
              Below are the {service.title.toLowerCase()} alterations we offer.
              All prices are starting estimates and may vary based on fabric type,
              garment structure, and labor required.
            </p>
          </div>

          <div className="service-items-list">
            {service.services.map((item, index) => (
              <div className="service-item" key={index}>
                <div className="service-item-number">{String(index + 1).padStart(2, '0')}</div>
                <div className="service-item-content">
                  <h3>{item.name}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="service-detail-cta">
            <h3>Ready to Get Started?</h3>
            <p>Walk-In for a consultation. Contact for more information.</p>
            <button onClick={handleContactClick} className="btn-primary">
              Contact Us
            </button>
          </div>
        </div>
      </section>

    </div>
  );
}
